import Markdown from "react-markdown";
import { Link } from "react-router";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { getDocContent } from "~/app/lib/docs.server";
import type { Route } from "./+types/docs.$slug";

export async function loader({ params }: Route.LoaderArgs) {
  const content = getDocContent(params.slug);
  if (!content) {
    throw new Response("Not found", { status: 404 });
  }
  return { content };
}

export default function DocsPage({ loaderData }: Route.ComponentProps) {
  return (
    <div className="prose max-w-3xl prose-headings:font-semibold prose-headings:tracking-tight prose-headings:text-gray-900 prose-h1:text-2xl prose-h1:border-b prose-h1:border-gray-100 prose-h1:pb-3 prose-h2:text-xl prose-h2:mt-10 prose-h3:text-base prose-p:text-gray-600 prose-p:leading-relaxed prose-a:text-[#023220] prose-a:no-underline hover:prose-a:underline prose-strong:text-gray-900 prose-li:text-gray-600 prose-table:text-sm">
      <Markdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          a: ({ href, children, ...props }) => {
            if (href?.startsWith("./") && href.endsWith(".md")) {
              const slug = href
                .replace("./", "")
                .replace(".md", "")
                .replace(/^\d+-/, "");
              return (
                <Link to={`/docs/${slug}`} {...props}>
                  {children}
                </Link>
              );
            }
            return (
              <a href={href} {...props}>
                {children}
              </a>
            );
          },
        }}
      >
        {loaderData.content}
      </Markdown>
    </div>
  );
}
